import script from "./UploadImagemAvulsaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadImagemAvulsaModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadImagemAvulsaModal.vue?vue&type=style&index=0&id=2a12ac1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a12ac1e"]])

export default __exports__